import { render, staticRenderFns } from "./PatientHistoryMaintenance.vue?vue&type=template&id=bc09b3fe&scoped=true&"
import script from "./PatientHistoryMaintenance.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./PatientHistoryMaintenance.vue?vue&type=style&index=0&id=bc09b3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc09b3fe",
  null
  
)

export default component.exports